import {IDLE} from "../../common/statuses";

export const RECEIPT = "receipt";

export const initialState = {
    getPayments: {
        data: undefined,
        status: IDLE,
        error: undefined,
    },
    loadReceipt: {
        status: IDLE,
        message: undefined,
    },
    deletePayment: {
        status: IDLE,
        message: undefined,
    },
    confirmPayment: {
        status: IDLE,
        message: undefined,
    },
}